"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerStateFlow = void 0;
const state_flow_1 = require("@video/state-flow");
// type is different for convenience, so we don't need
// to use `typeof PlayerStateFlow` everywhere
exports.PlayerStateFlow = new state_flow_1.StateFlow();
//# sourceMappingURL=state-flow.js.map